import { useParams } from "react-router-dom";

interface CustomQueryVariablesProps {
  search: string;
  prevOptions: unknown[];
}

export default function useCustomQueryVariables() {
  const urlParams: RouteParams = useParams();

  const customQueryVariables = ({ search, prevOptions }: CustomQueryVariablesProps) => {
    const variables = {
      filter: {
        companyId: urlParams.companyId,
        isActive: true,
        search: search,
        code_Istartswith_In: search ? undefined : ["7"],
      },
      limit: 100,
      offset: prevOptions.length,
    };
    return variables;
  };

  return customQueryVariables;
}
